/**
 * Finnish Translations — Impact Core i18n
 *
 * Flat key-value structure. Keys use dot notation for namespacing.
 * Coverage: navigation, actions, statuses, dashboard labels, form labels.
 */

export const fi: Record<string, string> = {
  // Navigation
  'nav.dashboard': 'Kojelauta',
  'nav.funds': 'Rahastot',
  'nav.investments': 'Sijoitukset',
  'nav.investees': 'Sijoituskohteet',
  'nav.esg': 'ESG Katsaus',
  'nav.compliance': 'Vaatimustenmukaisuus',
  'nav.reports': 'Raportit',
  'nav.settings': 'Asetukset',
  'nav.users': 'Käyttäjät',
  'nav.sfdr': 'SFDR',
  'nav.pai': 'PAI Indikaattorit',
  'nav.taxonomy': 'EU-taksonomia',
  'nav.filings': 'Ilmoitukset',
  'nav.calendar': 'Kalenteri',
  'nav.submit': 'Lähetä tiedot',
  'nav.submissions': 'Omat lähetykset',
  'nav.benchmarks': 'Vertailuarvot',
  'nav.messages': 'Viestit',
  'nav.portfolio': 'Salkku',
  'nav.performance': 'Rahastojen tulokset',
  'nav.esgSummary': 'ESG Yhteenveto',
  'nav.pipeline': 'Putki',
  'nav.dueDiligence': 'Due Diligence',
  'nav.impact': 'Vaikuttavuusmittarit',
  'nav.sdg': 'SDG-kartoitus',
  'nav.audit': 'Tarkastusjälki',
  'nav.snapshots': 'Tietovedokset',
  'nav.knowledgeGraph': 'Tietograafi',
  'nav.geographic': 'Maantieteellinen',
  'nav.bi': 'BI Studio',
  'nav.ai': 'AI Avustaja',
  'nav.tasks': 'Tehtävät',
  'nav.csrd': 'CSRD',
  'nav.regulatory': 'Sääntelymonitori',

  // Common Actions
  'action.create': 'Luo',
  'action.edit': 'Muokkaa',
  'action.delete': 'Poista',
  'action.save': 'Tallenna',
  'action.cancel': 'Peruuta',
  'action.submit': 'Lähetä',
  'action.approve': 'Hyväksy',
  'action.reject': 'Hylkää',
  'action.download': 'Lataa',
  'action.export': 'Vie',
  'action.import': 'Tuo',
  'action.filter': 'Suodata',
  'action.search': 'Hae',
  'action.refresh': 'Päivitä',
  'action.close': 'Sulje',
  'action.back': 'Takaisin',
  'action.next': 'Seuraava',
  'action.previous': 'Edellinen',
  'action.viewAll': 'Näytä kaikki',
  'action.viewDetails': 'Näytä tiedot',
  'action.generate': 'Luo raportti',
  'action.signOut': 'Kirjaudu ulos',
  'action.addNew': 'Lisää uusi',
  'action.invite': 'Kutsu',

  // Statuses
  'status.draft': 'Luonnos',
  'status.submitted': 'Lähetetty',
  'status.validated': 'Vahvistettu',
  'status.approved': 'Hyväksytty',
  'status.rejected': 'Hylätty',
  'status.pending': 'Odottaa',
  'status.inProgress': 'Käynnissä',
  'status.overdue': 'Myöhässä',
  'status.compliant': 'Vaatimustenmukainen',
  'status.filed': 'Ilmoitettu',
  'status.active': 'Aktiivinen',
  'status.inactive': 'Ei-aktiivinen',
  'status.closed': 'Suljettu',
  'status.fundraising': 'Varainhankinta',
  'status.investing': 'Sijoittaminen',
  'status.harvesting': 'Tuotonkorjuu',

  // Dashboard Labels
  'dashboard.portfolioOverview': 'Salkkuyhteenveto',
  'dashboard.complianceStatus': 'Vaatimustenmukaisuuden tila',
  'dashboard.collectionProgress': 'Keruun edistyminen',
  'dashboard.activityFeed': 'Toiminta',
  'dashboard.quickActions': 'Pikatoiminnot',
  'dashboard.investmentPipeline': 'Sijoitusputki',
  'dashboard.totalFunds': 'Rahastoja yhteensä',
  'dashboard.aum': 'AUM',
  'dashboard.activeInvestments': 'Aktiiviset sijoitukset',
  'dashboard.totalInvestees': 'Sijoituskohteet',
  'dashboard.recentActivity': 'Viimeaikainen toiminta',

  // LP Dashboard Labels
  'lp.totalCommitted': 'Sitoutunut yhteensä',
  'lp.capitalCalled': 'Kutsuttu pääoma',
  'lp.distributed': 'Jaettu',
  'lp.netPosition': 'Nettopositio',
  'lp.tvpi': 'TVPI',
  'lp.dpi': 'DPI',
  'lp.fundPerformance': 'Rahastojen tulokset',
  'lp.esgSummary': 'ESG Yhteenveto',
  'lp.reportLibrary': 'Raporttikirjasto',
  'lp.taxonomyAligned': 'Taksonomian mukainen',
  'lp.paiCoverage': 'PAI Kattavuus',
  'lp.portfolioPerformance': 'LP Salkun tulokset',

  // Fund Labels
  'fund.name': 'Rahaston nimi',
  'fund.code': 'Rahaston koodi',
  'fund.vintage': 'Perustamisvuosi',
  'fund.size': 'Rahaston koko',
  'fund.targetSize': 'Tavoitekoko',
  'fund.currency': 'Valuutta',
  'fund.strategy': 'Strategia',
  'fund.status': 'Tila',
  'fund.sfdrCategory': 'SFDR Luokka',
  'fund.geographyFocus': 'Maantieteellinen painopiste',
  'fund.sectorFocus': 'Sektoripainopiste',

  // Form Labels
  'form.name': 'Nimi',
  'form.email': 'Sähköposti',
  'form.country': 'Maa',
  'form.amount': 'Määrä',
  'form.currency': 'Valuutta',
  'form.date': 'Päivämäärä',
  'form.description': 'Kuvaus',
  'form.notes': 'Muistiinpanot',
  'form.type': 'Tyyppi',
  'form.period': 'Kausi',
  'form.year': 'Vuosi',
  'form.required': 'Pakollinen',
  'form.optional': 'Valinnainen',

  // Table Headers
  'table.fund': 'Rahasto',
  'table.commitment': 'Sitoumus',
  'table.called': 'Kutsuttu',
  'table.distributed': 'Jaettu',
  'table.tvpi': 'TVPI',
  'table.status': 'Tila',
  'table.regulation': 'Sääntely',
  'table.filingType': 'Ilmoitustyyppi',
  'table.reportingPeriod': 'Kausi',
  'table.createdAt': 'Luotu',
  'table.actions': 'Toiminnot',

  // Compliance
  'compliance.sfdr': 'SFDR',
  'compliance.taxonomy': 'EU-taksonomia',
  'compliance.pai': 'PAI',
  'compliance.dataCompleteness': 'Tietojen kattavuus',
  'compliance.nextDeadline': 'Seuraava määräaika',

  // Reports
  'report.quarterly': 'Neljännesvuosiraportti',
  'report.annual': 'Vuosiraportti',
  'report.paiStatement': 'PAI Lausunto',
  'report.taxonomyReport': 'Taksonomiaraportti',
  'report.generatedAt': 'Luotu',
  'report.version': 'Versio',

  // General
  'general.loading': 'Ladataan...',
  'general.noData': 'Ei tietoja saatavilla',
  'general.error': 'Tapahtui virhe',
  'general.retry': 'Yritä uudelleen',
  'general.total': 'Yhteensä',
  'general.page': 'Sivu',
  'general.of': '/',
  'general.showing': 'Näytetään',
  'general.results': 'tulosta',
  'general.language': 'Kieli',
  'general.english': 'Englanti',
  'general.french': 'Ranska',

  // Tour
  'tour.takeTour': 'Aloita kierros',
  'tour.skip': 'Ohita',
  'tour.next': 'Seuraava',
  'tour.prev': 'Edellinen',
  'tour.finish': 'Valmis',
};
